export  class Permission {
    authitemid: string;
    authitemname: string;
    canadd: Boolean = false;
    canapprove: Boolean = false;
    candelete: Boolean = false;
    canedit: Boolean = false;
    canprint: Boolean = false;
    canview: Boolean = false;
    canviewlog: Boolean = false;

    toString() : string
    {
        return  "authid:".concat(this.authitemid)
        .concat(", authname:")
        .concat(this.authitemname)
        .concat(", canadd:")
        .concat(this.canadd + "")
        .concat(", canapprove:")
        .concat(this.canapprove + "")
        .concat(", candelete:")
        .concat(this.candelete + "")
        .concat(", canedit:")
        .concat(this.canedit + "")
        .concat(", canview:")
        .concat(this.canview + "");
    }

}


// WEBPACK FOOTER //
// ./src/app/client/models/permission.ts